import React from 'react';
import { ExternalLink } from 'lucide-react';
import { formatInline } from '../../utils/messageFormatter';

export function PayloadFields({ fields }) {
  const entries = Object.entries(fields || {});
  if (entries.length === 0) return null;

  return (
    <div
      className="rounded-[7px] p-2.5 mb-2.5 grid gap-x-4 gap-y-1"
      style={{ background: 'rgba(0,0,0,.2)', gridTemplateColumns: '120px 1fr' }}
    >
      {entries.map(([key, value], i) => (
        <React.Fragment key={i}>
          <span className="text-[11px] text-ink-mute py-px self-center">{key}</span>
          <span className="text-[11px] text-ink-dim font-mono py-px">{formatInline(String(value))}</span>
        </React.Fragment>
      ))}
    </div>
  );
}

export function PayloadActions({ actions }) {
  if (!actions || actions.length === 0) return null;

  return (
    <div className="flex gap-1.5 flex-wrap">
      {actions.map((a, i) => (
        <a
          key={i}
          href={a.url}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 text-[11px] font-bold text-ink-dim bg-white/[.05] border border-white/10 px-3 py-1.5 rounded-[7px] no-underline hover:bg-white/[.09] transition-colors"
        >
          {a.label}
          <ExternalLink className="h-2.5 w-2.5" />
        </a>
      ))}
    </div>
  );
}
